import { render, staticRenderFns } from "./CandidateCertifications.vue?vue&type=template&id=4e13a69a&"
import script from "./CandidateCertifications.vue?vue&type=script&lang=js&"
export * from "./CandidateCertifications.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports